import { render, staticRenderFns } from "./badgeManage.vue?vue&type=template&id=4ae3a3a3&scoped=true&"
import script from "./badgeManage.vue?vue&type=script&lang=js&"
export * from "./badgeManage.vue?vue&type=script&lang=js&"
import style0 from "./badgeManage.vue?vue&type=style&index=0&id=4ae3a3a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae3a3a3",
  null
  
)

export default component.exports